import { render, staticRenderFns } from "./ComptaWidgetIcon.vue?vue&type=template&id=4a0df742"
import script from "./ComptaWidgetIcon.vue?vue&type=script&lang=js"
export * from "./ComptaWidgetIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports